import React from "react";
import { Gauge } from "lucide-react";
import { CareerCard } from "./CareerCard";
import { scoreBarColor, scoreColor } from "@/lib/careerConfig";
import { cn } from "@/lib/utils";
import { translateFr as tfr } from "@/i18n";

function ScoreGauge({ score, label }) {
  const r = 52;
  const c = 2 * Math.PI * r;
  const pct = score === null || score === undefined ? 0 : score;
  const stroke = pct >= 80 ? "#22C55E" : pct >= 50 ? "#F5A524" : "#E5484D";
  return (
    <div className="relative h-[132px] w-[132px] mx-auto" role="img"
      aria-label={score === null ? tfr("Career readiness : données insuffisantes") : `Career readiness : ${score}% — ${label}`}>
      <svg viewBox="0 0 120 120" className="h-full w-full -rotate-90">
        <circle cx="60" cy="60" r={r} fill="none" strokeWidth="9" className="stroke-secondary" />
        {score !== null && score !== undefined && (
          <circle
            cx="60" cy="60" r={r} fill="none" strokeWidth="9" stroke={stroke} strokeLinecap="round"
            strokeDasharray={c} strokeDashoffset={c - (c * pct) / 100}
            style={{ transition: "stroke-dashoffset 600ms ease" }}
          />
        )}
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className={cn("text-3xl font-bold tabular-nums", scoreColor(score))} data-testid="readiness-score">
          {score === null || score === undefined ? "—" : `${score}%`}
        </span>
        <span className="text-[11px] text-muted-foreground mt-0.5">{label || tfr("Données insuffisantes")}</span>
      </div>
    </div>
  );
}

export function ReadinessCard({ readiness }) {
  return (
    <CareerCard icon={Gauge} title="Career Readiness" subtitle={tfr("Préparation du dossier")} testid="readiness-card">
      <ScoreGauge score={readiness.score} label={readiness.label} />
      <ul className="mt-5 space-y-3">
        {readiness.dimensions.map((d) => (
          <li key={d.key} data-testid={`readiness-dim-${d.key}`}>
            <div className="flex items-center justify-between gap-2 mb-1">
              <span className="text-xs font-medium text-foreground/90" title={(d.reasons || []).join(" ")}>{d.label}</span>
              <span className={cn("text-xs font-semibold tabular-nums", scoreColor(d.score))}>
                {d.score === null ? "—" : `${d.score}%`}
              </span>
            </div>
            <div className="h-1.5 rounded-full bg-secondary overflow-hidden">
              {d.score !== null && (
                <div className={cn("h-full rounded-full", scoreBarColor(d.score))} style={{ width: `${d.score}%` }} />
              )}
            </div>
            {d.score === null && (
              <p className="text-[11px] text-muted-foreground mt-0.5">{(d.reasons || [])[0] || tfr("Données insuffisantes")}</p>
            )}
          </li>
        ))}
      </ul>
      <p className="text-[11px] text-muted-foreground mt-4 pt-3 border-t border-border">
        {tfr("Indicateur interne de préparation du dossier — ne prédit pas la réussite sportive.")}
      </p>
    </CareerCard>
  );
}
